<template>
  <div class="container">
    <BliEmptyState :image-src="UnableToLoadPageImage">
      <template #empty-state-title>
        {{ $t('common.internalServerError.title') }}
      </template>
      <template #empty-state-description>
        {{ $t('common.internalServerError.description') }}
      </template>
      <template #empty-state-button>
        <BliButton
          prominence="primary"
          @click="reload"
        >
          {{ $t('common.internalServerError.button.reload') }}
        </BliButton>
      </template>
    </BliEmptyState>
  </div>
</template>

<script src="./js/error-state.js" />
<style lang="scss" scoped>
.container {
  height: 70vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
